/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiReportsRouteImport } from './routes/ai-reports'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as QueueRouteImport } from './routes/queue'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminTabRouteImport } from './routes/admin/$tab'
import { Route as AdminWorkflowRouteImport } from './routes/admin/workflow'
import { Route as AppsIndexRouteImport } from './routes/apps/index'
import { Route as AppsNewRouteImport } from './routes/apps/new'
import { Route as MyRequestsIndexRouteImport } from './routes/my-requests/index'
import { Route as MyRequestsPublicIdRouteImport } from './routes/my-requests/$publicId'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as TicketsRefRouteImport } from './routes/tickets/$ref'
import { Route as AppsAppIdQueueRouteImport } from './routes/apps/$appId/queue'
import { Route as AppsAppIdSettingsIndexRouteImport } from './routes/apps/$appId/settings/index'
import { Route as AppsAppIdSettingsSectionRouteImport } from './routes/apps/$appId/settings/$section'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiReportsRoute = AiReportsRouteImport.update({
  id: '/ai-reports',
  path: '/ai-reports',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const QueueRoute = QueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTabRoute = AdminTabRouteImport.update({
  id: '/admin/$tab',
  path: '/admin/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkflowRoute = AdminWorkflowRouteImport.update({
  id: '/admin/workflow',
  path: '/admin/workflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsNewRoute = AppsNewRouteImport.update({
  id: '/apps/new',
  path: '/apps/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MyRequestsIndexRoute = MyRequestsIndexRouteImport.update({
  id: '/my-requests/',
  path: '/my-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const MyRequestsPublicIdRoute = MyRequestsPublicIdRouteImport.update({
  id: '/my-requests/$publicId',
  path: '/my-requests/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRefRoute = TicketsRefRouteImport.update({
  id: '/tickets/$ref',
  path: '/tickets/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdQueueRoute = AppsAppIdQueueRouteImport.update({
  id: '/apps/$appId/queue',
  path: '/apps/$appId/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdSettingsIndexRoute = AppsAppIdSettingsIndexRouteImport.update({
  id: '/apps/$appId/settings/',
  path: '/apps/$appId/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAppIdSettingsSectionRoute =
  AppsAppIdSettingsSectionRouteImport.update({
    id: '/apps/$appId/settings/$section',
    path: '/apps/$appId/settings/$section',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-reports': typeof AiReportsRoute
  '/dashboard': typeof DashboardRoute
  '/no-access': typeof NoAccessRoute
  '/notifications': typeof NotificationsRoute
  '/queue': typeof QueueRoute
  '/sign-in': typeof SignInRoute
  '/admin/$tab': typeof AdminTabRoute
  '/admin/workflow': typeof AdminWorkflowRoute
  '/apps/new': typeof AppsNewRoute
  '/my-requests/$publicId': typeof MyRequestsPublicIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/tickets/$ref': typeof TicketsRefRoute
  '/admin/': typeof AdminIndexRoute
  '/apps/': typeof AppsIndexRoute
  '/my-requests/': typeof MyRequestsIndexRoute
  '/apps/$appId/queue': typeof AppsAppIdQueueRoute
  '/apps/$appId/settings/$section': typeof AppsAppIdSettingsSectionRoute
  '/apps/$appId/settings/': typeof AppsAppIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-reports': typeof AiReportsRoute
  '/dashboard': typeof DashboardRoute
  '/no-access': typeof NoAccessRoute
  '/notifications': typeof NotificationsRoute
  '/queue': typeof QueueRoute
  '/sign-in': typeof SignInRoute
  '/admin/$tab': typeof AdminTabRoute
  '/admin/workflow': typeof AdminWorkflowRoute
  '/apps/new': typeof AppsNewRoute
  '/my-requests/$publicId': typeof MyRequestsPublicIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/tickets/$ref': typeof TicketsRefRoute
  '/admin': typeof AdminIndexRoute
  '/apps': typeof AppsIndexRoute
  '/my-requests': typeof MyRequestsIndexRoute
  '/apps/$appId/queue': typeof AppsAppIdQueueRoute
  '/apps/$appId/settings/$section': typeof AppsAppIdSettingsSectionRoute
  '/apps/$appId/settings': typeof AppsAppIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-reports': typeof AiReportsRoute
  '/dashboard': typeof DashboardRoute
  '/no-access': typeof NoAccessRoute
  '/notifications': typeof NotificationsRoute
  '/queue': typeof QueueRoute
  '/sign-in': typeof SignInRoute
  '/admin/$tab': typeof AdminTabRoute
  '/admin/workflow': typeof AdminWorkflowRoute
  '/apps/new': typeof AppsNewRoute
  '/my-requests/$publicId': typeof MyRequestsPublicIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/tickets/$ref': typeof TicketsRefRoute
  '/admin/': typeof AdminIndexRoute
  '/apps/': typeof AppsIndexRoute
  '/my-requests/': typeof MyRequestsIndexRoute
  '/apps/$appId/queue': typeof AppsAppIdQueueRoute
  '/apps/$appId/settings/$section': typeof AppsAppIdSettingsSectionRoute
  '/apps/$appId/settings/': typeof AppsAppIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-reports'
    | '/dashboard'
    | '/no-access'
    | '/notifications'
    | '/queue'
    | '/sign-in'
    | '/admin/$tab'
    | '/admin/workflow'
    | '/apps/new'
    | '/my-requests/$publicId'
    | '/oauth/consent'
    | '/tickets/$ref'
    | '/admin/'
    | '/apps/'
    | '/my-requests/'
    | '/apps/$appId/queue'
    | '/apps/$appId/settings/$section'
    | '/apps/$appId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-reports'
    | '/dashboard'
    | '/no-access'
    | '/notifications'
    | '/queue'
    | '/sign-in'
    | '/admin/$tab'
    | '/admin/workflow'
    | '/apps/new'
    | '/my-requests/$publicId'
    | '/oauth/consent'
    | '/tickets/$ref'
    | '/admin'
    | '/apps'
    | '/my-requests'
    | '/apps/$appId/queue'
    | '/apps/$appId/settings/$section'
    | '/apps/$appId/settings'
  id:
    | '__root__'
    | '/'
    | '/ai-reports'
    | '/dashboard'
    | '/no-access'
    | '/notifications'
    | '/queue'
    | '/sign-in'
    | '/admin/$tab'
    | '/admin/workflow'
    | '/apps/new'
    | '/my-requests/$publicId'
    | '/oauth/consent'
    | '/tickets/$ref'
    | '/admin/'
    | '/apps/'
    | '/my-requests/'
    | '/apps/$appId/queue'
    | '/apps/$appId/settings/$section'
    | '/apps/$appId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiReportsRoute: typeof AiReportsRoute
  DashboardRoute: typeof DashboardRoute
  NoAccessRoute: typeof NoAccessRoute
  NotificationsRoute: typeof NotificationsRoute
  QueueRoute: typeof QueueRoute
  SignInRoute: typeof SignInRoute
  AdminTabRoute: typeof AdminTabRoute
  AdminWorkflowRoute: typeof AdminWorkflowRoute
  AppsNewRoute: typeof AppsNewRoute
  MyRequestsPublicIdRoute: typeof MyRequestsPublicIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
  TicketsRefRoute: typeof TicketsRefRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AppsIndexRoute: typeof AppsIndexRoute
  MyRequestsIndexRoute: typeof MyRequestsIndexRoute
  AppsAppIdQueueRoute: typeof AppsAppIdQueueRoute
  AppsAppIdSettingsSectionRoute: typeof AppsAppIdSettingsSectionRoute
  AppsAppIdSettingsIndexRoute: typeof AppsAppIdSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-reports': {
      id: '/ai-reports'
      path: '/ai-reports'
      fullPath: '/ai-reports'
      preLoaderRoute: typeof AiReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queue': {
      id: '/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof QueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$tab': {
      id: '/admin/$tab'
      path: '/admin/$tab'
      fullPath: '/admin/$tab'
      preLoaderRoute: typeof AdminTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/workflow': {
      id: '/admin/workflow'
      path: '/admin/workflow'
      fullPath: '/admin/workflow'
      preLoaderRoute: typeof AdminWorkflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/new': {
      id: '/apps/new'
      path: '/apps/new'
      fullPath: '/apps/new'
      preLoaderRoute: typeof AppsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-requests/': {
      id: '/my-requests/'
      path: '/my-requests'
      fullPath: '/my-requests/'
      preLoaderRoute: typeof MyRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-requests/$publicId': {
      id: '/my-requests/$publicId'
      path: '/my-requests/$publicId'
      fullPath: '/my-requests/$publicId'
      preLoaderRoute: typeof MyRequestsPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$ref': {
      id: '/tickets/$ref'
      path: '/tickets/$ref'
      fullPath: '/tickets/$ref'
      preLoaderRoute: typeof TicketsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId/queue': {
      id: '/apps/$appId/queue'
      path: '/apps/$appId/queue'
      fullPath: '/apps/$appId/queue'
      preLoaderRoute: typeof AppsAppIdQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId/settings/': {
      id: '/apps/$appId/settings/'
      path: '/apps/$appId/settings'
      fullPath: '/apps/$appId/settings/'
      preLoaderRoute: typeof AppsAppIdSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$appId/settings/$section': {
      id: '/apps/$appId/settings/$section'
      path: '/apps/$appId/settings/$section'
      fullPath: '/apps/$appId/settings/$section'
      preLoaderRoute: typeof AppsAppIdSettingsSectionRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiReportsRoute: AiReportsRoute,
  DashboardRoute: DashboardRoute,
  NoAccessRoute: NoAccessRoute,
  NotificationsRoute: NotificationsRoute,
  QueueRoute: QueueRoute,
  SignInRoute: SignInRoute,
  AdminTabRoute: AdminTabRoute,
  AdminWorkflowRoute: AdminWorkflowRoute,
  AppsNewRoute: AppsNewRoute,
  MyRequestsPublicIdRoute: MyRequestsPublicIdRoute,
  OauthConsentRoute: OauthConsentRoute,
  TicketsRefRoute: TicketsRefRoute,
  AdminIndexRoute: AdminIndexRoute,
  AppsIndexRoute: AppsIndexRoute,
  MyRequestsIndexRoute: MyRequestsIndexRoute,
  AppsAppIdQueueRoute: AppsAppIdQueueRoute,
  AppsAppIdSettingsSectionRoute: AppsAppIdSettingsSectionRoute,
  AppsAppIdSettingsIndexRoute: AppsAppIdSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
